angular.module('calendarApp').directive('membershipModal', function () {
  return {
    restrict: 'AE',
    scope: {
      activationSuccess: '=',
      memberships: '=',
      defaultPayment: '='
    },
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/membership-modal.html',
    link: function link(scope, elem, attrs) {
      scope.currencySettings = smooth.currencySettings;
      scope.chosenPlan = null;

      var init = function init() {
        scope.form = {
          selectedMembershipIndex: 0
        };

        if (scope.memberships && scope.memberships.length) {
          scope.selectedMembership = scope.memberships[0];
          scope.memberships[0].selected = true;
        }

        scope.chosenPlan = null;
      };

      scope.chooseMembership = function () {
        scope.selectedMembership = scope.memberships[scope.form.selectedMembershipIndex];
        scope.chosenPlan = null;
      };

      scope.choosePlan = function (chosenPlan) {
        scope.chosenPlan = chosenPlan;
      };

      scope.showModal = function () {
        $('#choose-membership-modal').modal();
        init();
      };

      scope.toggleViewMemberships = function () {
        scope.viewMemberships = !scope.viewMemberships;
      }; // Membership successfully activated, just reload the payment options page.


      scope.membershipActivationSuccess = function () {};
    }
  };
}); // End directive